<template>
  <div class="login">
    <div class="logo"><img src="../assets/logo.png" alt="" /></div>
    <el-card class="box-card">
      <h3 style="font-weight: bold">ADMIN PORTAL</h3>

      <!-- <el-form ref="form" :model="form" :rules="rules">
        <el-form-item prop="username">
          <el-input
            placeholder="Email address"
            v-model="form.username"
            @keyup.enter.native="onSubmit('form')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            placeholder="Password "
            v-model="form.password"
            show-password
            @keyup.enter.native="onSubmit('form')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit('form')">Login</el-button>
        </el-form-item>
      </el-form> -->

      <form :action="this.link" method="post">
        <button
          class="el-button el-button--primary"
          type="submit"
          className="btn btn-outline-theme col-sm-3"
        >
          Login
        </button>
      </form>
      <!-- <el-button type="primary" @click="getCode()">
        Call /current-user/info
      </el-button> -->
    </el-card>

    <!-- <button @click="loginT">Login</button>
    <button @click="logoutT">Logout</button> -->
  </div>
</template>

<script>
import {
  apiLogin,
  apiPubKey,
  getPage,
  apiAzureAdLogin,
  currentUserInfo,
} from "@/request/api";
// import "../../src/request/http";

export default {
  name: "Login",
  data() {
    return {
      link: "",
      code: "",
      form: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "The Email address cannot be empty" },
        ],
        password: [{ required: true, message: "The Password cannot be empty" }],
      },
    };
  },
  methods: {
    getCode() {
      if (this.code) {
        this.$store.dispatch("UserLogin", this.code);
        currentUserInfo().then((res) => {
          console.log(res);
          console.log(res.data.accessToken);
          console.log(window.location.href);
          var str = window.location.href;
          let index = str.lastIndexOf("/?accessToken");
          str = str.substring(0, index);
          console.log(str); 
          if (res.status == 200) {
            this.$store.dispatch("UserLogin", res.data.accessToken);
            let userInfo = {};
            userInfo.menus = res.data.menus;
            userInfo.permissions = res.data.permissionCodes;
            let fullname = res.data.firstName;
            if (res.data.lastName) {
              fullname += " " + res.data.lastName;
            }
            userInfo.username = fullname;
            userInfo.refreshToken = res.data.refreshToken;
            userInfo.expireTime =
              Date.parse(new Date()) / 1000 + res.data.expireTime;
            userInfo.userLevel =
              res.data.userLevel == "SUPER_ADMIN"
                ? 1
                : res.data.userLevel == "CS_TEAM"
                ? 2
                : 3;
            userInfo.salesOffices = res.data.salesOffices;
            userInfo.regions = res.data.regions;
            this.$store.dispatch("UserInfo", JSON.stringify(userInfo));
            console.log(userInfo);
            window.open(str, "_self");
            this.$router.push("/clientManagement");
          } else {
            this.$message.error(res.statusText);
          }
        });
      } else {
        return;
      }
    },

    hrefInit() {
      this.link =
        window.location.protocol +
        process.env.API_ROOT +
        "/cmsauth/aad/login/page";
      console.log(window.sessionStorage);
      console.log(window.location.href);
      console.log("link= " + this.link);
      var thisHref = window.location.href;
      this.code = "";
      if (thisHref.indexOf("?accessToken=") > 0) {
        this.code = thisHref.slice(
          thisHref.indexOf("?accessToken=") + 13,
          thisHref.indexOf("#/login")
        );
      }
      console.log("code= " + this.code);
    },

    getPubKey() {
      let pubKey = window.sessionStorage.getItem("pubKey");
      if (!pubKey) {
        apiPubKey().then((res) => {
          if (res.status == 200) {
            if (res.data.status == "00") {
              let resPubKey = res.data.payload;
              window.sessionStorage.setItem("pubKey", resPubKey);
            } else {
              this.$message.error(res.data.msg);
            }
          } else {
            this.$message.error(res.statusText);
          }
        });
      }
    },
    async loginT() {
      await this.$msal.signIn();
    },
    logoutT() {
      this.$msal
        .signOut()
        .then(() => {
          // 注销成功后的处理逻辑
        })
        .catch((error) => {
          alert("error2");
          // 处理注销错误
          console.error(error);
        });
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let rasPw = this.$encryptedRSAOAEP(this.form.password);
          apiLogin({
            username: this.form.username,
            password: rasPw,
          }).then((res) => {
            if (res.status == 200) {
              if (res.data.status == "00") {
                this.$store.dispatch("UserLogin", res.data.payload.accessToken);
                let userInfo = {};
                userInfo.menus = res.data.payload.menus;
                userInfo.permissions = res.data.payload.permissionCodes;
                let fullname = res.data.payload.firstName;
                if (res.data.payload.lastName) {
                  fullname += " " + res.data.payload.lastName;
                }
                userInfo.username = fullname;
                userInfo.refreshToken = res.data.payload.refreshToken;
                userInfo.expireTime =
                  Date.parse(new Date()) / 1000 + res.data.payload.expireTime;
                userInfo.userLevel =
                  res.data.payload.userLevel == "SUPER_ADMIN"
                    ? 1
                    : res.data.payload.userLevel == "CS_TEAM"
                    ? 2
                    : 3;
                userInfo.salesOffices = res.data.payload.salesOffices;
                userInfo.regions = res.data.payload.regions;
                this.$store.dispatch("UserInfo", JSON.stringify(userInfo));
                console.log(userInfo);
                this.$router.push("/clientManagement");
              } else {
                this.$message.error(res.data.msg);
              }
            } else {
              this.$message.error(res.statusText);
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  created: function () {
    this.getPubKey();
    this.$emit("header", false);
    this.hrefInit();
    this.getCode();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {
  margin: calc(50vh - 274px) auto 0;
}
.login .logo {
  margin-bottom: 30px;
}
.login .logo img {
  width: 200px;
}
.login .box-card {
  width: 450px;
  margin: auto;
}
.login .box-card h3 {
  text-align: center;
  color: #003448;
  margin: 10px 0 40px;
  font-size: 24px;
  letter-spacing: 1px;
}
.login >>> .el-form-item__content {
  font-size: 0;
}
.login .el-form-item {
  margin-bottom: 40px;
}
.login .el-input {
  width: 327px;
  vertical-align: middle;
}
.login .el-icon-user-solid,
.login .icon-lock {
  font-size: 26px;
  vertical-align: middle;
  color: #003448;
  margin-right: 10px;
}
.login >>> .el-form-item__error {
  left: 57px;
}
.login .el-button {
  width: 327px;
  margin-top: 8px;
  font-size: 16px;
}
.login .forgot {
  font-size: 12px;
  color: #303133;
  display: block;
  line-height: 1;
  margin-top: 5px;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue